import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BLEMISH_COLOR } from '../../../../../constants/blemish_color.constats';

class BlemishIcon extends Component {
    constructor(props) {
        super(props);
    }
    iconStylesHandler = () => {
        const { isBlemishModal } = this.props;
        const iconStyles = isBlemishModal ?
            {
                fontSize: 19,
                marginRight: 4,
                color: '#ccc',
            }
            :
            {
                fontSize: 30,
                color: '#ccc',
            };

        if (this.props.Lead_blemish_report && this.props.Lead_blemish_report.blemish_report) {
            const { rag_rating } = this.props.Lead_blemish_report.blemish_report;

            if (rag_rating) {
                iconStyles.color = BLEMISH_COLOR[rag_rating];
            }
        }
        return iconStyles;
    }

    render() {
        return <span className="fa fa-notes-medical" style={this.iconStylesHandler()} />;
    }
}

const mapStateToProps = (state) => ({
    Lead_blemish_report: state.Leads.Lead_profile.Lead_blemish_report,
});


export default connect(mapStateToProps)(BlemishIcon);


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/components/BlemishIcon/index.js